// Labelled image placeholder for the Archive Prospectus.
// Renders a clearly identified frame until final images are supplied.
const ASPECTS = {
  portrait: "aspect-[4/5]",
  landscape: "aspect-[3/2]",
  square: "aspect-square",
  wide: "aspect-[21/9]",
};

export const ProspectusFigure = ({ image, full = false }) => {
  if (!image) return null;
  return (
    <figure
      className={`my-14 md:my-20 ${full ? "" : "max-w-3xl"}`}
      data-testid={`prospectus-figure-${image.label}`}
    >
      <div
        className={`relative w-full ${ASPECTS[image.aspect] || ASPECTS.landscape} border border-dashed border-[color:var(--muted)] bg-[color:var(--bone-deep)] flex flex-col items-center justify-center gap-3 px-6 text-center`}
      >
        <span className="font-mono text-xs md:text-sm tracking-[0.2em] opacity-70">
          [ {image.label} ]
        </span>
        <span className="font-serif italic text-sm md:text-base opacity-50 max-w-[46ch]">
          {image.note}
        </span>
      </div>
      <figcaption className="mt-4 flex flex-col gap-1">
        <span className="font-serif italic text-sm md:text-base opacity-75">
          {image.caption}
        </span>
        <span className="hairline opacity-40">Credit: {image.credit}</span>
      </figcaption>
    </figure>
  );
};
